import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import { scale, getRandomInRange, getRandomRGBColor } from "./utils";

const Color = require("color");

class CanvasAnimator extends LitElement {
    static get properties() {
        return {};
    }

    constructor() {
        super();

        this.notePlaying = false;

        WebMidi.enable((error) => {
            if (error) {
                console.log(error);
            } else {
                const midiSource = WebMidi.getInputByName("Arturia MINILAB");
                midiSource.addListener(
                    "noteon",
                    "all",
                    this.handleNoteOn.bind(this)
                );
                midiSource.addListener(
                    "noteoff",
                    "all",
                    this.handleNoteOff.bind(this)
                );
                midiSource.addListener(
                    "controlchange",
                    "all",
                    this.handleControlChange.bind(this)
                );
            }
        });
    }

    handleNoteOn(e) {
        // this.notePlaying = true;
        // this.video = this.shadowRoot.querySelector("video");
        // this.canvas = this.shadowRoot.querySelector("canvas");
        // this.canvas.width = this.video.videoWidth;
        // this.canvas.height = this.video.videoHeight;
        // this.updateCanvas();
    }

    handleNoteOff(e) {
        // this.notePlaying = false;
        // this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    handleControlChange(e) {
        const cc = e.controller.number;

        if (cc === 20) {
            this.r = e.value;
        } else if (cc === 21) {
            this.g = e.value;
        } else if (cc === 22) {
            this.b = e.value;
        } else if (cc === 23) {
            this.a = e.value;
        }
    }

    firstUpdated() {
        this.video = this.shadowRoot.querySelector("video");
        this.canvas = this.shadowRoot.querySelector("canvas");

        this.video.addEventListener("play", () => {
            this.canvas.width = this.video.videoWidth;
            this.canvas.height = this.video.videoHeight;

            this.updateCanvas();
        });
    }

    updateCanvas() {
        this.context = this.canvas.getContext("2d");

        if (this.video.ended || this.video.paused) {
            return;
        }

        this.context.drawImage(
            this.video,
            0,
            0,
            this.video.videoWidth,
            this.video.videoHeight
        );

        const frame = this.context.getImageData(
            0,
            0,
            this.canvas.width,
            this.canvas.height
        );

        const l = frame.data.length / 4;

        let r = scale(this.r, 0, 127, 0, 255);
        for (let i = 0; i < l; i++) {
            let r = frame.data[i * 4 + 0];
            let g = frame.data[i * 4 + 1];
            let b = frame.data[i * 4 + 2];
            if (r > 50) {
                frame.data[i * 4 + 0] = scale(this.r, 0, 127, 0, 255);
            }
            if (g > 50) {
                frame.data[i * 4 + 1] = scale(this.g, 0, 127, 0, 255);
            }
            if (b > 50) {
                frame.data[i * 4 + 2] = scale(this.b, 0, 127, 0, 255);
            }
        }

        this.context.putImageData(frame, 0, 0);

        requestAnimationFrame(this.updateCanvas.bind(this));
    }

    render() {
        return html`
            <style>
                video {
                    position: absolute;
                    visibility: hidden;
                }
                canvas {
                    width: 100vw;
                    height: 100vh;
                }
            </style>
            <div id="container">
                <video src="../../videos/quintuplets.mp4" autoplay loop></video>
                <canvas></canvas>
            </div>
        `;
    }
}

customElements.define("canvas-animator", CanvasAnimator);
